module.exports = __webpack_public_path__ + "static/media/sidebar-2.7202f505.png";